class BundlePicker extends HTMLElement {
  constructor() {
    super();
    this.init();
  }
  init() { }
}
customElements.define('bundle-picker', BundlePicker);

class BundlePickerOption extends HTMLElement {
  constructor() {
    super();
    this.init();
  }
  init() {
    this.productForm = document.querySelector('product-form');
    this.bundlePicker = this.closest('bundle-picker');
    this.button = this.querySelector('.bundle-handle');
    this.button.addEventListener('change', this.onBundleSelected.bind(this));
    if (+this.dataset.defaultSelected === 1) {
      this.button.checked = true;
      this.button.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
  get variantIdInput() {
    return this.productForm.querySelector('[name=id]');
  }
  get productIdInput() {
    return this.productForm.querySelector('[name=product-id]')
  }
  get childVariantContainer() {
    return document.querySelector('#bundle-picker-options-container ul');
  }
  get childVariant() {
    if (!this.dataset?.bundleVariantSelector) return false;
    return this.querySelector(`template#${this.dataset.bundleVariantSelector}`);
  }
  get regularPriceElement() {
    return document.querySelector('.price__regular .price-item--regular');
  }
  get comparePriceElement() {
    return document.querySelector('.price__sale .price-item--compare');
  }
  get salePriceElement() {
    return document.querySelector('.price__sale .price-item--sale');
  }
  setSelectedBundleTitle() {
    if (!this.bundlePicker) return;
    const setTitle = (selector, defaultTitle) => {
      const titleElement = this.bundlePicker.querySelector(selector);
      if (!titleElement) return;
      titleElement.textContent = this.dataset?.title || defaultTitle;
    };
    if (this.dataset?.optionType === 'bundle') {
      setTitle('.bundle-picker-title .title-from-selected', `Bundle ${this.dataset?.index}`);
    }
    if (this.dataset?.optionType === 'option') {
      setTitle('#bundle-picker-options-container .bundle-picker-title .title-from-selected', `Option ${this.dataset?.index}`);
    }
  }
  setSelectedBundlePrice() {
    const regularPrice = this.dataset?.priceCompareMoneyWithCurrency;
    const salePrice = this.dataset?.priceMoneyWithCurrency;
    // Update the sale price, if available
    if (salePrice && this.salePriceElement) {
      this.salePriceElement.textContent = salePrice; // Update the visible text
      this.salePriceElement.dataset.price = salePrice; // Update the data-price attribute
    }
    // Update the regular price, if available
    if (regularPrice && this.regularPriceElement) {
      this.regularPriceElement.textContent = regularPrice; // Update the visible text
      this.regularPriceElement.dataset.price = regularPrice; // Update the data-price attribute
    } else {
      this.regularPriceElement.textContent = ''; // Update the visible text
      this.regularPriceElement.dataset.price = ''; // Update the data-price attribute
    }
    // Update the compare price (original price before the sale), if available
    if (regularPrice && this.comparePriceElement) {
      this.comparePriceElement.textContent = regularPrice; // Update the visible text
      this.comparePriceElement.dataset.price = regularPrice; // Update the data-price attribute
    } else {
      this.comparePriceElement.textContent = ''; // Update the visible text
      this.comparePriceElement.dataset.price = ''; // Update the data-price attribute
    }
  }
  onBundleSelected() {
    this.productIdInput.value = this.dataset.productId;
    if (this.dataset?.variantId) {
      this.variantIdInput.value = this.dataset.variantId;
    }
    if (this.childVariant) {
      this.childVariantContainer.closest('.bundle-picker-options').classList.remove('open');
      while (this.childVariantContainer.firstChild) {
        this.childVariantContainer.removeChild(this.childVariantContainer.firstChild);
      }
      let variantNodes = this.childVariant?.content?.children || [];
      if (!Array.isArray(variantNodes)) {
        variantNodes = Array.from(variantNodes);
        // Reverse the array to make the last item first
        variantNodes.reverse();
      }

      for (const node of variantNodes) {
        const li = document.createElement('li');
        li.appendChild(node?.cloneNode(true));
        this.childVariantContainer.appendChild(li);
      }

      // Initialize the child variant options
      setTimeout(() => {
        this.childVariantContainer.closest('.bundle-picker-options').classList.add('open');
        // Select the first item (which was the last in the original array)
        const firstOption = this.childVariantContainer.querySelector('bundle-picker-option');
        if (firstOption) {
          const button = firstOption.querySelector('.bundle-handle');
          if (button) {
            button.checked = true;
            button.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      }, 4);
    }
    this.setSelectedBundleTitle();
    this.setSelectedBundlePrice();
  }
}
customElements.define('bundle-picker-option', BundlePickerOption);
